<template>
  <div class="user-side-menu-container" :class="{ open: isUserMenuOpen }">
    <div class="menu-header">
      <div class="user-greeter">
        {{ auth.name + " " + $t("generics.hello") }} <span v-if="showCompany"> | {{ companyName }}</span>
      </div>
      <div class="user-info">
        {{ $t("generics.subscription") + ": " + plan }}
        |
        {{ $t("toolbar.created") }}
        {{ gamesCount }}/{{ gamesInPlan }}
      </div>
    </div>
    <div class="menu-icon-container">
      <v-img src="/img/usermenu_logo.png" contain max-height="80px" eager />
    </div>
    <div class="menu-nav">
      <router-link text :to="{ name: 'types-circles' }" class="menu-nav-btn">
        <v-row justify="space-around">
          <v-col cols="3" class="text-center">
            <span class="menu-icon">
              <v-icon icon="share" height="25px">mdi-gamepad-variant-outline</v-icon>
            </span>
          </v-col>
          <v-col>
            <span class="link">{{ $t("toolbar.createGame") }}</span>
          </v-col>
        </v-row>
      </router-link>
      <router-link text :to="{ name: 'games-page' }" class="menu-nav-btn">
        <v-row justify="space-around">
          <v-col cols="3">
            <span class="menu-icon"><v-img src="/img/i05.png" contain max-height="25px" eager /></span>
          </v-col>
          <v-col>
            <span class="link">{{ $t("toolbar.mygames") }}</span>
          </v-col>
        </v-row>
      </router-link>
      <router-link text :to="{ name: 'plans-page', query: { hf: 't' } }" class="menu-nav-btn">
        <v-row justify="space-around">
          <v-col cols="3">
						<span class="menu-icon"><v-img src="/img/usermenu_upgrade.png" contain max-height="25px"
                                           eager /></span>
          </v-col>
          <v-col>
            <span class="link">{{ $t("pages.popup.upgrade.sub") }}</span>
          </v-col>
        </v-row>
      </router-link>
      <router-link v-if="isTeamHead" text :to="{ name: 'center-manage' }" class="menu-nav-btn">
        <v-row justify="space-around">
          <v-col cols="3" class="text-center">
						<span class="menu-icon">
							<v-icon max-height="25px">mdi-account-group-outline</v-icon>
						</span>
          </v-col>
          <v-col>
            <span class="link">{{ $t("Center Management") }}</span>
          </v-col>
        </v-row>
      </router-link>


      <a :href="auth.gallery_link" target="_blank" class="menu-nav-btn">
        <v-row justify="space-around">
          <v-col class="text-center" cols="3">
            <v-icon
                icon="share"
                height="25px"
            >share
            </v-icon>
          </v-col>
          <v-col>
            <a class="pointer" @click.prevent="copyGameLink">{{ this.$t("generics.copylink") }}</a>
            <span class="link">| MyLab</span>
          </v-col>
        </v-row>
      </a>
      <a href="/logout" class="menu-nav-btn">
        <v-row justify="space-around">
          <v-col cols="3">
						<span class="menu-icon"><v-img src="/img/usermenu_logout.png" contain max-height="25px"
                                           eager /></span>
          </v-col>
          <v-col>
            <span class="link">{{ $t("generics.logout") }}</span>
          </v-col>
        </v-row>
      </a>
      <a v-if="auth.is_edu" target="_blank" :href="educationMyAccount" class="menu-nav-btn">
        <v-row justify="space-around">
          <v-col cols="3">
						<span class="menu-icon"><v-img src="/img/account.png" contain max-height="25px"
                                           eager /></span>
          </v-col>
          <v-col>
            <span class="link">{{ $t("generics.myAccount") }}</span>
          </v-col>
        </v-row>
      </a>
      <lang-select class="lang-select" />

    </div>
  </div>
</template>

<script>
import { types as AuthTypes } from "../store/modules/Auth.module";
import { mapGetters } from "vuex";
import * as clipboard from "clipboard-polyfill/text";
import LangSelect from "src/components/LangSelect";
export default {
  name: "UserSideMenu",
  components: {
    LangSelect,
  },
  computed: {
    ...mapGetters([
      "companyName",
      "isCompany",
    ]),
    showCompany(){
      return this.isCompany || this.auth.is_edu;
    },
    educationMyAccount() {
      return 'http://appslimud.education.gov.il/EduLogin/myaccount.aspx';
    },
    isUserMenuOpen() {
      return this.$store.getters.isUserMenuOpen;
    },
    auth() {
      return this.$store.state.AuthModule.user;
    },
    subscription() {
      return this.$store.getters.subscription;
    },
    isTeamHead() {
      return this.$store.getters.isTeamHead;
    },
    gamesCount() {
      return this.$store.getters.gamesCount;
    },
    gamesInPlan() {
      return this.$store.getters.gamesInPlan;
    },
    plan() {
      //There are two names for the free plan in ClapWay, so I'm checknig both of them
      if (
          !!this.subscription &&
          ["FreeLab", "חינמית"].includes(this.subscription.plan)
      ) {
        return this.$t("generics.free");
      } else {
        return this.$t("toolbar.proPlan");
      }
    },
  },
  methods: {
    copyGameLink() {
      clipboard.writeText(this.auth.gallery_link);
      this.$notification.success(this.$t("share.url_copy_success"));
    },
    logout() {
      this.$store.dispatch(AuthTypes.LOGOUT).then(() => {
        location.reload();
      });
    },
    logoutPassport() {
      this.$store.dispatch(AuthTypes.LOGOUT_PASSPORT)
    }
  },
  created() {
    window.addEventListener('click', (e) => {
      if (this.isUserMenuOpen && !this.$el.contains(e.target) && e.target.classList.contains('user-menu-toggler') == false) {
        this.$store.commit("closeUserMenu");
      }
    })
  },
  watch:{
    $route (to, from){
      this.$store.commit("closeUserMenu");
    }
  },
};
</script>

<style lang="scss" scoped>
.user-side-menu-container {
  background-color: white;
  height: calc(100% - 130px);
  position: absolute;
  width: 350px;
  margin-top: -12px;
  z-index: 999;
  right: -350px;
  transition: right 300ms;

  &.open {
    right: 0;
  }

  .menu-icon-container {
    margin: 25px 0;
  }

  .menu-header {
    filter: drop-shadow(5.563px 2.248px 3.5px rgba(0, 0, 0, 0.24));
    background-color: #f3f4f5;
    font-size: 0.85em;
    padding: 20px 50px;

    .user-greeter {
      font-weight: bold;
    }
  }

  .menu-nav {
    padding: 0 50px;

    .menu-nav-btn {
      display: block;
      color: #4d4d4d;
      text-decoration: none;
      margin-top: 15px;
    }
  }
}
</style>
